import { Component, OnInit, inject, input, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { OwlOptions, CarouselModule } from 'ngx-owl-carousel-o';
import { Store } from '@ngxs/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IpDetectorState } from 'src/app/store/ip-detector/ip-detector.state';
import * as _ from 'underscore';
import { filter, finalize, take } from 'rxjs/operators';
import { LaunchDarklyState } from 'src/app/store/launch-darkly/launch-darkly.state';
import { SITE_DATA } from 'src/app/productization/default.constant';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
    imports: [CarouselModule, RouterLink, FormsModule]
})
export class HeroComponent implements OnInit {
	readonly countryOrigin = input<string | null>(null);
	private readonly store = inject(Store);
	private readonly destroyRef = inject(DestroyRef);
	private readonly getIpAddress = this.store.select(IpDetectorState.getIp);
	private readonly ngxLoader = inject(NgxUiLoaderService);
	private readonly router = inject(Router);

	contentOptions: OwlOptions = {
		loop: true,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		navSpeed: 700,
		animateOut: 'animate__animated animate__fadeOutUp',
		animateIn: 'animate__animated animate__fadeInUp',
		responsive: {
			0: {
				items: 1
			},
			400: {
				items: 1
			},
			740: {
				items: 1
			},
			940: {
				items: 1
			}
		},
		nav: false,
		autoplay: true
	};
	imageOptions: OwlOptions = {
		loop: true,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		navSpeed: 700,
		animateOut: 'animate__animated animate__fadeOut',
		animateIn: 'animate__animated animate__fadeIn',
		responsive: {
			0: {
				items: 1
			},
			400: {
				items: 1
			},
			740: {
				items: 1
			},
			940: {
				items: 1
			}
		},
		nav: false,
		autoplay: true
	};

	public images = SITE_DATA.lander.hero.backgroundImages;
	public slideShow = SITE_DATA.lander.hero.slideShow;
	public filteredImages: any[];
	public searchText: string;
	private userCountry: string;

	private readonly launchDarklyResult$ = this.store.select(
		LaunchDarklyState.getFlags
	);

	public ldFlags: any;

	public ngOnInit(): void {
		this.ngxLoader.start();
		this.getIpAddress
			.pipe(
				filter((e: any) => !_.isEmpty(e)),
				take(1),
				finalize(() => {
					this.ngxLoader.stop();
				})
			)
			.subscribe({
				next: (e: any) => {
					this.userCountry = e.country_name;
					this.countryImages();
				},
				error: () => {
					this.filteredImages = this.images.filter((img) =>
						img.includes('ph-')
					);
				}
			});

		this.launchDarklyResult$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((flags) => {
			this.ldFlags = flags;
		});
	}

	public search() {
		if (this.searchText) {
			const setParam: any = { search: this.searchText };
			if (this.countryOrigin()) {
				setParam.location = this.userCountry;
			}
			this.router.navigate(['/job-list'], {
				queryParams: setParam
			});
		} else {
			this.router.navigate(['/job-list']);
		}
	}

	private countryImages(): void {
		const countryMap: { [key: string]: string } = {
			australia: 'au-',
			india: 'in-',
			colombia: 'co-',
			philippines: 'ph-'
		};
		const countryKey = this.userCountry?.toLowerCase() || '';
		const prefix = countryMap[countryKey] || 'ph-';
		const filtered = this.images.filter((img) => img.includes(prefix));
		this.filteredImages = filtered.length > 0 ? filtered : this.images;
	}
}
